<template>
  <b-card class="mb-4">
    <ais-instant-search
      :search-function="searchFunction"
      :routing="routing"
      :search-client="searchClient"
      :index-name="indexName"
    >
      <b-row>
        <b-col>
          <ais-search-box class="mb-4">
            <div class="search-input" slot-scope="{ refine }">
              <form name="search_form">
                <b-input
                  v-model="searchQuery"
                  placeholder="Search here..."
                  type="search"
                  ref="searchField"
                  :autofocus="Boolean(searchQuery)"
                  @input="refine(searchQuery)"
                />
              </form>
            </div>
          </ais-search-box>

          <refresh-search ref="refresh" />

          <b-form-group v-if="refinedFacetList" label="Exact Filter" v-slot="{ ariaDescribedby }">
            <b-form-radio-group
              v-model="searchableFacet"
              :options="refinedFacetList"
              :aria-describedby="ariaDescribedby"
            />
          </b-form-group>

          <ais-configure v-if="refinedFacetList" :restrictSearchableAttributes="searchableAttributes" />

          <ais-hits>
            <div slot-scope="{ items }">
              <slot :items="items" />
            </div>
          </ais-hits>

          <ais-pagination class="mt-4" />
        </b-col>

        <b-col v-if="refinementList" cols="2">
          <div class="mb-2" v-for="(refinement, index) in refinementList" :key="index">
            <h6>{{ refinement.text }}</h6>
            <ais-refinement-list :attribute="refinement.value" />
          </div>
        </b-col>
      </b-row>
    </ais-instant-search>
  </b-card>
</template>

<script>
import { configureSearchClient } from '../pages/page-helpers'
import 'instantsearch.css/themes/algolia-min.css'
import debounce from 'lodash/debounce'
import RefreshSearch from './RefreshSearch.vue'

export default {
  name: 'DisplayResults',
  components: { RefreshSearch },
  props: {
    indexName: { type: String },
    query: { type: String },
    refinementList: { type: Array },
    facetList: { type: Array },
  },
  data() {
    const vueRouter = this.$router

    return {
      searchQuery: this.$route.query.query,
      searchClient: configureSearchClient(
        process.env.VUE_APP_ALGOLIA_ID,
        process.env.VUE_APP_ALGOLIA_SEARCH_KEY,
        process.env.VUE_APP_ALGOLIA_LOCAL_READ_API
      ),
      routing: {
        router: {
          read() {
            return vueRouter.currentRoute.query
          },
          write(routeState) {
            vueRouter.push({
              query: routeState,
            })
          },
          createURL(routeState) {
            return vueRouter.resolve({
              query: routeState,
            }).href
          },
          onUpdate(cb) {
            this._onPopState = event => {
              const routeState = event.state

              // at initial load, the state is read from the URL without
              // update. Therefore the state object is not there. In this
              // case we fallback and read the URL.
              if (!routeState) {
                cb(this.read())
              } else {
                cb(routeState)
              }
            }
            window.addEventListener('popstate', this._onPopState)
          },
          dispose() {
            window.removeEventListener('popstate', this._onPopState)
            this.write()
          },
        },
        stateMapping: {
          stateToRoute: uiState => {
            return {
              query: uiState[this.indexName].query,
              page: uiState[this.indexName].page,
            }
          },
          routeToState: routeState => {
            return {
              [this.indexName]: {
                query: routeState.query,
                page: routeState.page,
              },
            }
          },
        },
      },
      searchableFacet: '__everything',
    }
  },
  methods: {
    searchFunction(helper) {
      this.search(helper, this.searchQuery)
    },
    triggerSearch() {
      this.$refs.refresh.$el.click()
    },
    search: debounce((helper, query) => {
      const page = helper.getPage() // Retrieve the current page

      helper
        .setQuery(query) // this call resets the page
        .setPage(page) // we re-apply the previous page
        .search()
    }, 300),
  },
  computed: {
    refinedFacetList() {
      if (!this.facetList) return

      return [{ text: 'Everything', value: '__everything' }].concat(this.facetList)
    },
    searchableAttributes() {
      if (this.searchableFacet === '' || this.searchableFacet === '__everything') {
        return []
      }

      return [this.searchableFacet]
    },
  },
}
</script>
